module.exports = __webpack_public_path__ + "media/sora2-demo-1.f2836c69.mp4";